<template>
  <v-container fluid>
    {{inp}}
    <v-text-field v-model="inp" outlined/>
    <v-textarea v-model="inp" outlined/>
    <v-select
        v-model="inp"
        :items="['1', '2', '3']"
        outlined
        clearable
    ></v-select>
    <v-autocomplete
        v-model="inp"
        :items="['123','234', '345']"
        outlined
        clearable
    ></v-autocomplete>
    <v-btn>Button</v-btn>
  </v-container>

</template>

<script>
import {mixinScanner} from "@/components/Common/MixinScanner"

export default {
  name: "TestScanner",
  mixins: [mixinScanner],

  data() {
    return {
      inp: null,
    };
  },

  mounted() {
  },

  destroyed() {
  },

  methods: {
    finishScan(scanBuffer) {
      console.log('finishScan', scanBuffer)
    }
  }
}


</script>

<style scoped>

</style>